import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

const StylableTooltip = ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ tooltip: className }} />
);

export default StylableTooltip;
